export const deClientPortalTaskSideDrawerPages = {
    taskSideDrawer: {
        common: {
            cancelAriaLabel: 'Abbrechen',
            submitAriaLabel: 'Speichern',
        },
        header: {
            editTitleAriaLabel: 'Titel bearbeiten',
            form: {
                updateErrorMessage: 'Es ist ein Fehler beim Senden der Änderungen aufgetreten. Bitte erneut versuchen.',
            },
        },
        orderDetails: {
            title: 'Auftragsdaten',
            orderName: 'Auftragsname',
            valuationDate: 'Wertermittlungsstichtag',
            orderStatus: 'Auftragsstatus',
            appraiser: 'Bewerter/in',
            asset: 'Immobilie',
            portfolio: 'Portfolio',
            portfolios: 'Portfolios',
            appraiserAssignment: {
                addButton: 'Gutachter/in hinzufügen',
                modal: {
                    customOptionName: '► Extern (Freitext)',
                    customOptionGroup: 'Nicht registrierte Gutachter',
                    title: 'Zuständige Gutachter/innen',
                    cancel: 'Abbrechen',
                    duplicateWarning: 'Derselbe Gutachter wurde mehrfach ausgewählt. Bitte ändern Sie einen der Einträge.',
                    customInfo:
                        'Freitext bitte nur für nicht registrierte Gutachter verwenden. Automatisierungen funktionieren nur mit verknüpften Gutachtern.',
                    mainAppraiser: 'Erstgutachter/in',
                    secondaryAppraiser: 'Zweitgutachter/in',
                    tertiaryAppraiser: 'Drittgutachter/in',
                    nameAndCertification: 'Name und Zertifizierung',
                    remove: 'Entfernen',
                    addSecondary: 'Zweitgutachter/in hinzufügen',
                    addTertiary: 'Drittgutachter/in hinzufügen',
                },
            },
        },
        changeLog: {
            todayAt: 'heute um {{time}} Uhr',
            onDate: 'am {{date}}',
            createdBy: 'Aufgabe erstellt von {{userName}} {{dateOrTime}}',
            createdAutomatically: 'Diese Aufgabe wurde automatisch erstellt {{dateOrTime}}',
            closedBy: 'Aufgabe abgeschlossen von {{userName}} {{dateOrTime}}',
            closedAutomatically: 'Diese Aufgabe wurde automatisch abgeschlossen {{dateOrTime}}',
        },
        details: {
            title: 'Aufgabendetails',
            assignee: 'Zuständig',
            customerVisibility: 'Sichtbarkeit für Kunden',
            hidden: 'Versteckt',
            visible: 'Sichtbar',
            taskType: 'Aufgabentyp',
            deadline: 'Deadline',
            notSet: 'Nicht festgelegt',
            description: 'Beschreibung',
            showLess: 'Weniger anzeigen',
            showMore: 'Mehr anzeigen',
            form: {
                updateErrorMessage: 'Es ist ein Fehler beim Senden der Änderungen aufgetreten. Bitte erneut versuchen.',
                updateErrorTitle: 'Fehler',
                hiddenSecondary: '(unsichtbar für Kunden)',
                cancelAriaLabel: 'Abbrechen',
                submitAriaLabel: 'Speichern',
            },
        },
        attachments: {
            title: 'Dokumente',
            downloadAllAriaLabel: 'Alle Dokumente herunterladen',
            editDocumentsAriaLabel: 'Dokumente bearbeiten',
            uploadDocumentsAriaLabel: 'Dokumente hochladen',
            uploadDisabledTooltip: 'Dokumente können bei Aufträgen mit externer Mailbox nur in einer Nachricht versendet werden.',
            modal: {
                uploadTitle: 'Dokumente hochladen',
                editTitle: 'Dokumente bearbeiten',
                createButton: 'Erstellen',
                confirmButton: 'Bestätigen',
                cancelButton: 'Abbrechen',
                dropzonePrompt: 'Datei auswählen oder per Drag & Drop hochladen',
                nameLabel: 'Name',
                tagsLabel: 'Tags',
                unknownMimeTypeLabel: 'Unbekannt',
                uploadErrorAlert: {
                    title: 'Fehler beim Hochladen der Dateien',
                    description: 'Folgende Dateien konnten nicht erfolgreich hochgeladen werden:',
                    supportText: 'Bitte versuchen Sie es erneut oder schreiben Sie eine Nachricht an support@einwert.com',
                },
            },
            item: {
                edit: 'Bearbeiten',
                delete: 'Löschen',
                optionsAriaLabel: 'Aufgaben-Anhänge Optionen',
            },
        },
    },
}
